import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader, callApi } from "../Helpers";
import { MdCheck } from "react-icons/md";

export default function VisitationRegistrationForm({ data, callback }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [visitationDate, setVisitationDate] = useState("");
	const [triageTierUuid, setTriageTierUuid] = useState("");
	const [bloodPressure, setBloodPressure] = useState("");
	const [temperature, setTemperature] = useState("");
	const [pulseRate, setPulseRate] = useState("");
	const [weight, setWeight] = useState("");
	const [respiratoryRate, setRespiratoryRate] = useState("");
	const [spO2, setSpO2] = useState("");
	const [presentingComplaint, setPresentingComplaint] = useState("");
	const [chiefComplaint, setChiefComplaint] = useState("");
	const [hpi, setHpi] = useState("");
	const [existingAllergies, setExistingAllergies] = useState("");
	const [currentMedications, setCurrentMedications] = useState("");
	const [socialHistory, setSocialHistory] = useState("");
	const [pmh, setPmh] = useState("");
	const [generalPatientReview, setGeneralPatientReview] = useState("");
	const [forwardedTo, setForwardedTo] = useState("");
	const [patientUuid, setPatientUuid] = useState("");

	async function init() {
		//run initializations here
		setReady(false);
		//..
		setReady(true);
	}

	function resetForm() {
		setVisitationDate("");
		setTriageTierUuid("");
		setBloodPressure("");
		setTemperature("");
		setPulseRate("");
		setWeight("");
		setRespiratoryRate("");
		setSpO2("");
		setPresentingComplaint("");
		setChiefComplaint("");
		setHpi("");
		setExistingAllergies("");
		setCurrentMedications("");
		setSocialHistory("");
		setPmh("");
		setGeneralPatientReview("");
		setForwardedTo("");
		setPatientUuid("");
	}

	async function create() {
		if(visitationDate.trim().length > 0) {
			setLoading(true);
			await callApi(
				'create-visitation',
				{
					visitationDate,
					triageTierUuid,
					bloodPressure,
					temperature,
					pulseRate,
					weight,
					respiratoryRate,
					spO2,
					presentingComplaint,
					chiefComplaint,
					hpi,
					existingAllergies,
					currentMedications,
					socialHistory,
					pmh,
					generalPatientReview,
					forwardedTo,
					patientUuid,
				}
			).then(response => {
				if(response.status === 1) {
					if(appContext.getAllVisitations) {
						appContext.getAllVisitations();
					}
					appContext.tellMessage("Successful");
					resetForm()
				} else {
					appContext.tellError(response.msg)
				}
			})
			setLoading(false);
		} else {
			appContext.tellError("Invalid visitation date");
		}
	}

	async function edit() {
		if(visitationDate.trim().length > 0) {
			setLoading(true);
			await callApi(
				'edit-visitation',
				{
					uuid: data.uuid,
					visitationDate,
					triageTierUuid,
					bloodPressure,
					temperature,
					pulseRate,
					weight,
					respiratoryRate,
					spO2,
					presentingComplaint,
					chiefComplaint,
					hpi,
					existingAllergies,
					currentMedications,
					socialHistory,
					pmh,
					generalPatientReview,
					forwardedTo,
					patientUuid,
				}
			).then(response => {
				if(response.status === 1) {
					if(appContext.getAllVisitations) {
						appContext.getAllVisitations();
					}
					appContext.tellMessage("Successful");
					
					if(callback) {
						callback();
					}
				} else {
					appContext.tellError(response.msg)
				}
			})
			setLoading(false);
		} else {
			appContext.tellError("Invalid visitation date");
		}
	}

	useEffect(() => {
		if(data) {
			setVisitationDate(data.visitationDate || "");
			setTriageTierUuid(data.triageTierUuid || "");
			setBloodPressure(data.bloodPressure || "");
			setTemperature(data.temperature || "");
			setPulseRate(data.pulseRate || "");
			setWeight(data.weight || "");
			setRespiratoryRate(data.respiratoryRate || "");
			setSpO2(data.spO2 || "");
			setPresentingComplaint(data.presentingComplaint || "");
			setChiefComplaint(data.chiefComplaint || "");
			setHpi(data.hpi || "");
			setExistingAllergies(data.existingAllergies || "");
			setCurrentMedications(data.currentMedications || "");
			setSocialHistory(data.socialHistory || "");
			setPmh(data.pmh || "");
			setGeneralPatientReview(data.generalPatientReview || "");
			setForwardedTo(data.forwardedTo || "");
			setPatientUuid(data.patientUuid || "");
		}
	}, [ data ])

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready) {
		return (
		
			<div className="row">

				<div className="col-md-12 mt-5 mb-1">
					<h6 className="text-primary font-bold" style={{ fontSize: "14px", textTransform: "uppercase" }}>Patient & Visit Details</h6>
					
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">Patient</label>
					<select
						className="form-control"
						value={patientUuid}
						onChange={e => setPatientUuid(e.target.value)}
					>
						<option value="">Select patient</option>
					</select>
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">Visitation Date</label>
					<input
						className="form-control"
						value={visitationDate}
						onChange={e => setVisitationDate(e.target.value)}
						placeholder="Enter visitation date"
						type="datetime-local"
					/>
				</div>

				<div className="col-md-12 mt-5 mb-1">
					<h6 className="text-primary font-bold" style={{ fontSize: "14px", textTransform: "uppercase" }}>Triage / Vitals</h6>
					
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">Triage Tier</label>
					<select
						className="form-control"
						value={triageTierUuid}
						onChange={e => setTriageTierUuid(e.target.value)}
					>
						<option value="">Select triage tier</option>
						<option value="urgent">Urgent</option>
						<option value="semi-urgent">Semi-Urgent</option>
						<option value="Routine">Routine</option>
					</select>
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">Blood Pressure</label>
					<input
						className="form-control"
						value={bloodPressure}
						onChange={e => setBloodPressure(e.target.value)}
						placeholder="Eg. 120/80"
					/>
				</div>

				<div className="col-md-4 mt-2 mb-2">
					<label className="form-label">Temperature</label>
					<input
						className="form-control"
						value={temperature}
						onChange={e => setTemperature(e.target.value)}
					/>
				</div>

				<div className="col-md-4 mt-2 mb-2">
					<label className="form-label">Pulse Rate</label>
					<input
						className="form-control"
						value={pulseRate}
						onChange={e => setPulseRate(e.target.value)}
					/>
				</div>

				<div className="col-md-4 mt-2 mb-2">
					<label className="form-label">Weight</label>
					<input
						className="form-control"
						value={weight}
						onChange={e => setWeight(e.target.value)}
					/>
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">Respiratory Rate</label>
					<input
						className="form-control"
						value={respiratoryRate}
						onChange={e => setRespiratoryRate(e.target.value)}
					/>
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">SpO2</label>
					<input
						className="form-control"
						value={spO2}
						onChange={e => setSpO2(e.target.value)}
					/>
				</div>

				<div className="col-md-12 mt-5 mb-1">
					<h6 className="text-primary font-bold" style={{ fontSize: "14px", textTransform: "uppercase" }}>Complaints</h6>
					
				</div>

				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Presenting Complaint</label>
					<textarea
						className="form-control"
						value={presentingComplaint}
						onChange={e => setPresentingComplaint(e.target.value)}
					/>
				</div>

				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Chief Complaint</label>
					<textarea
						className="form-control"
						value={chiefComplaint}
						onChange={e => setChiefComplaint(e.target.value)}
					/>
				</div>

				<div className="col-md-12 mt-5 mb-1">
					<h6 className="text-primary font-bold" style={{ fontSize: "14px", textTransform: "uppercase" }}>History & Review</h6>
					
				</div>

				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">HPI</label>
					<textarea
						className="form-control"
						value={hpi}
						onChange={e => setHpi(e.target.value)}
					/>
				</div>

				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Existing Allergies</label>
					<textarea
						className="form-control"
						value={existingAllergies}
						onChange={e => setExistingAllergies(e.target.value)}
					/>
				</div>

				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Current Medications</label>
					<textarea
						className="form-control"
						value={currentMedications}
						onChange={e => setCurrentMedications(e.target.value)}
					/>
				</div>

				<div className="col-md-12 mt-5 mb-1">
					<label className="form-label">Social History</label>
					<textarea
						className="form-control"
						value={socialHistory}
						onChange={e => setSocialHistory(e.target.value)}
					/>
				</div>

				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">PMH</label>
					<textarea
						className="form-control"
						value={pmh}
						onChange={e => setPmh(e.target.value)}
					/>
				</div>

				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">General Patient Review</label>
					<textarea
						className="form-control"
						value={generalPatientReview}
						onChange={e => setGeneralPatientReview(e.target.value)}
					/>
				</div>

				<div className="col-md-12 mt-5 mb-1">
					<h6 className="text-primary font-bold" style={{ fontSize: "14px", textTransform: "uppercase" }}>Forwarding</h6>
					
				</div>

				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Forwarded To</label>
					<select
						className="form-control"
						value={forwardedTo}
						onChange={e => setForwardedTo(e.target.value)}
					>
						<option value="">Select destination</option>
						<option value="Exam Room 1">Exam Room - Room 1</option>
						<option value="Exam Room 2">Exam Room - Room 2</option>
						<option value="Exam Room 3">Exam Room - Room 3</option>
						<option value="Exam Room 4">Exam Room - Room 4</option>
						<option value="Laboratory">Laboratory</option>
						<option value="Radiology Room">Radiology Room</option>
						<option value="Pharmacy">Pharmacy</option>
					</select>
				</div>

				<div className="col-md-12 mt-2 mb-2 text-end">
					<button
						className="btn btn-secondary"
						onClick={() => {
							if(data) {
								appContext.activateDialog({
									message: `Edit this visitation?`,
									onConfirm: edit,
								})
							} else {
								appContext.activateDialog({
									message: `Create new visitation?`,
									onConfirm: create,
								})
							}
						}}
					>
						<MdCheck/> Submit
					</button>
				</div>
			</div>
								
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

}